import type { MRT_ColumnFiltersState } from "material-react-table";

export function createNameFilter(columnFilters: MRT_ColumnFiltersState) {
  const filters: { name?: string } = {};

  const getTrimmedString = (value: unknown) =>
    typeof value === "string" ? value.trim() : "";

  columnFilters.forEach((filter) => {
    const colName = filter.id.split(".")[1] ?? filter.id;
    const trimmedValue = getTrimmedString(filter.value);
    if (trimmedValue === "") return;

    if (colName === "name") {
      filters.name = trimmedValue;
    }
  });

  return filters;
}
